import { frontendURL } from '../../../helper/URLHelper';

const FreemiumOnboarding = () => import('./Freemium.vue');

export const routes = [
  {
    path: frontendURL('accounts/:accountId/onboarding/free'),
    name: 'onboarding_free',
    component: FreemiumOnboarding,
    meta: {
      permissions: ['administrator'],
    },
  },
  {
    path: frontendURL('accounts/:accountId/onboarding/freemium'),
    redirect: to => ({
      name: 'onboarding_free',
      params: to.params,
      query: to.query,
    }),
  },
];

export default { routes };
